module.exports = __webpack_public_path__ + "img/20250909171300513.0f1d9f70.jpg";